import React from 'react';
import PropTypes from 'prop-types';
import { withMediaListener, testable } from '@xingternal/malt-util';
import Close from '@xingternal/malt-close';
import Canvas, {
  CanvasContent,
  CanvasClose,
  BACKGROUND_TRANSPARENT,
  BACKGROUND_WHITE,
  CLOSE_COLOR_BLACK,
  CLOSE_COLOR_WHITE,
} from '@xingternal/malt-canvas';
import { ModalWindow } from '@xingternal/malt-modal';
import styles from './TaskWindow.css';
import classNames from 'classnames';
import { QA_MALT } from '@xingternal/malt-constants';

const TestableDiv = testable(QA_MALT, 'div');

const TaskWindow = ({
  onClose,
  children,
  className,
  matchedMedia,
  portalContainerId,
  topGradient,
  testId,
}) => {
  const isHandheld = matchedMedia === 'handheld';
  const backgroundStyle = isHandheld
    ? BACKGROUND_WHITE
    : BACKGROUND_TRANSPARENT;
  const Content = isHandheld ? TestableDiv : ModalWindow;

  return (
    <Canvas
      portalContainerId={portalContainerId}
      onClick={!isHandheld ? onClose : undefined}
      backgroundStyle={backgroundStyle}
    >
      {isHandheld && (
        <CanvasClose
          onClick={onClose}
          color={topGradient ? CLOSE_COLOR_WHITE : CLOSE_COLOR_BLACK}
        />
      )}
      <CanvasContent fill={isHandheld}>
        <Content
          className={classNames(
            styles.content,
            { [styles.contentTopGradient]: topGradient && isHandheld },
            className
          )}
          testId={testId}
        >
          {!isHandheld && <Close className={styles.close} onClick={onClose} />}
          {children}
        </Content>
      </CanvasContent>
    </Canvas>
  );
};

TaskWindow.displayName = 'TaskWindow';

TaskWindow.propTypes = {
  /** A callback that is invoked when the close button or background is clicked */
  onClose: PropTypes.func.isRequired,
  /** Content of the TaskWindow */
  children: PropTypes.node.isRequired,
  /** Define a portal container into which the task window should be rendered via `id`. This falls back to a simple `div` appended to the `body` tag. The `div` gets removed again when closing the task window. */
  portalContainerId: PropTypes.string,
  /** Add a linear gradient on top of the content area */
  topGradient: PropTypes.bool,
  /** A custom className for the TaskWindow content container */
  className: PropTypes.string,
  /** @private */
  matchedMedia: PropTypes.string,
  /** define a testid for the task window */
  testId: PropTypes.string,
};

export default withMediaListener(TaskWindow);
